import { GoLinkExternal } from "react-icons/go";
import whiteLogo from "../../../assets/logo.svg";
import "../../css/footer.css";

export default function Footer() {
  return (
    <>
      <footer className="footer-section pt-3 pb-2">
        <div className="container text-center">
          {/* Logo */}
          <div className="mb-3">
            <a href="/">
              <img src={whiteLogo} alt="logo" width="200" />
            </a>
          </div>

          <p className="footer-text mb-2">
            We’re simplifying your TestOps experience with FrothAI
          </p>

          {/* Powered by */}
          <div className="mb-3">
            <a
              href="https://roboticodigital.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link d-inline-flex align-items-center text-decoration-none"
            >
              Powered by
              <span className="powered-text ms-1">Robotico Digital</span>
              <GoLinkExternal className="ms-1" />
            </a>
          </div>

          <h4 className="fw-support mb-1">SUPPORT</h4>

          {/* Links */}
          <ul className="list-inline">
            <li className="list-inline-item mx-2">
              <a
                href="/Froth_TestOps_Brochure.pdf"
                download="Froth_TestOps_Brochure.pdf"
                className="footer-link"
              >
                About
              </a>
            </li>

            {/* <li className="list-inline-item mx-2">
              <a
                href="https://demo-api.frothtestops.com/swagger/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                API
              </a>
            </li> */}

            <li className="list-inline-item mx-2">
              <a
                href="https://roboticodigital.gitbook.io/https-frothtestops.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                User Guide
              </a>
            </li>

            <li className="list-inline-item mx-2">
              <a href="/login" className="footer-link">
                Self Support
              </a>
            </li>
          </ul>
        </div>
      </footer>

      {/* Bottom Strip */}
      <div className="footer-bottom py-3 border-top text-center">
        <div className="container">
          <div className="d-flex align-items-center justify-content-center">
            <div className="mb-2 d-flex">
              <a href="/privacy-policy" className="footer-link me-3">
                Privacy Policy
              </a>
              <div className="footer-divider"></div>
              <a href="/term-condition" className="footer-link ms-3">
                Terms & Conditions
              </a>
            </div>

           
          </div>
           <p className="mb-1 ms-2 footer-text">
              © {new Date().getFullYear()} Copyright Robotico Digital.
            </p>
          <p className=" footer-text">
            Designed by{" "}
            <a
              href="https://technox.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link fw-semibold "
            >
              Technox
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
